export default [
  {
    path: '/trip-config',
    name: 'trip-config',
    component: () => import('@/views/trip-configurations/pages/TripConfigurations.vue'),
    meta: {
      resource: 'trips-config',
      action: 'read',
      requiresAuth: true,
      pageTitle: 'Trip Configurations',
      breadcrumb: [
        {
          text: 'Trip Configurations',
          active: true,
        },
      ],
      allowedCountries: ['LY'],
    },
  },
  {
    path: '/trip-config/edit/:zone/:service',
    name: 'trip-config-edit',
    component: () => import('@/views/trip-configurations/pages/EditTripConfig.vue'),
    meta: {
      resource: 'trips-config',
      action: 'write',
      requiresAuth: true,
      pageTitle: 'Edit Trip Config',
      breadcrumb: [
        {
          text: 'Trip Configurations',
          to: '/trip-config',
        },
      ],
      allowedCountries: ['LY'],
    },
  },
  {
    path: '/trip-config/new/:zone/:service',
    name: 'trip-config-new',
    component: () => import('@/views/trip-configurations/pages/AddTripConfig.vue'),
    meta: {
      resource: 'trips-config',
      action: 'write',
      requiresAuth: true,
      pageTitle: 'New Trip Config',
      breadcrumb: [
        {
          text: 'Trip Configurations',
          to: '/trip-config',
        },
      ],
      allowedCountries: ['LY'],
    },
  },

]
